export const PlugIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="14" height="22">
		<path
			fill="currentColor"
			d="M3 6V1c0-.552.448-1 1-1s1 .448 1 1v5h4V1c0-.552.447-1 1-1 .553 0 1 .448 1 1v5h2c.553 0 1 .448 1 1v5c0 2.757-2.243 5-5 5H8v4c0 .553-.448 1-1 1s-1-.447-1-1v-4H5c-2.757 0-5-2.243-5-5V7c0-.552.448-1 1-1h2Zm6 9c1.654 0 3-1.346 3-3V8H2v4c0 1.654 1.346 3 3 3h4Z"
		/>
	</svg>
);
